import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { supportApi as r } from "@maat/api-main";
//#region src/support/admin/useAdminFaqMutations.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.adminCreateFaq(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.faqs() });
		}
	});
}, a = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, payload: t }) => r.adminUpdateFaq(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.faqs() });
		}
	});
}, o = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.adminDeleteFaq(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.faqs() });
		}
	});
};
//#endregion
export { i as useCreateAdminFaqMutation, o as useDeleteAdminFaqMutation, a as useUpdateAdminFaqMutation };
